module.exports = __webpack_public_path__ + "static/media/very_spicy.4a3b5136.png";